export default "__VITE_PUBLIC_ASSET__110446a4__"